import addToMailchimp from 'gatsby-plugin-mailchimp';
import styled from 'styled-components'
import React, { useState } from 'react';
// import * as styles from './EmailListForm.module.scss';

const Submit = styled(`input`)`
  border:1px solid ${(props) => props.theme.colors.secondary};
  border-left: none;
	display:inline-block;
	cursor:pointer;
	color: ${(props) => props.theme.colors.primary};
  padding: 0.5rem 1rem;
  text-decoration:none;
  background: transparent;
  font-family: ${(props) => props.theme.fontCondensed};
  :focus {
   
    outline: 0;
  
  }
`

const SingleLineInput = styled(`input`)`

  padding: 0.5rem 1rem;
  border-width: 1px;
  border-color: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.primary};
  border-style: solid;
  border-radius: 0px;
  width: 50%;
  font-family: ${(props) => props.theme.fontCondensed};
  :focus {
   
    outline: 0;
  
  }
    ::placeholder {
    color: ${(props) => props.theme.colors.primary};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${(props) => props.theme.colors.primary};
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props) => props.theme.colors.primary};
  }
`

const Form = styled.form`
  top: -1rem;
  position: relative;
  font-family: ${(props) => props.theme.fontCondensed};
`

const Subscribe: React.FunctionComponent<{}> = () => {

  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    addToMailchimp(email)
      .then((data) => {
        alert(data.result);
      })
      .catch((error: Error) => {
        // Errors in here are client side 
        // Mailchimp always returns a 200
      });
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.currentTarget.value);
  };

  return (

    <Form onSubmit={handleSubmit}>

      <SingleLineInput
        type="text"
        name="email"
        placeholder="Enter email to get updates"
        className="email-input"
        required
        onChange={handleEmailChange}
      />
      <Submit type="submit" className="submit-email" value="Submit" />
    </Form>
  );
};

export default Subscribe;